import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconResultsStyle0 = gravityIconIndividualCss;

const GravityIconResults = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '0f9b1a372333e7707d51f0c4ce8ebafc89931899', color: this.color, size: this.size }, h("svg", { key: 'be99ea34c22be354c514e9918d8bcf3384632eea', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '403fb9edbc606908672985a25017bfd1e70805a2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.93 4.06 1.9.16c.3.04.37.21.13.38l-1.5 1.28L13 7.7c.09.28-.05.39-.29.22L11 6.84 9.3 7.92c-.3.17-.39.06-.3-.22l.57-1.87-1.51-1.27c-.24-.18-.18-.39.12-.39L10.1 4l.66-1.73c.1-.28.28-.28.4 0l.77 1.79ZM7.5 10a.5.5 0 0 0-.5.5V14H2.51a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H15v-3.5a.5.5 0 0 0-.5-.5h-7Zm6.01 1.5V15a.5.5 0 0 0 .5.5h4.5v3h-15v-3H8a.5.5 0 0 0 .5-.5v-3.5h5.01Z", fill: "currentColor" }))));
    }
};
GravityIconResults.style = GravityIconResultsStyle0;

export { GravityIconResults as gravity_icon_results };

//# sourceMappingURL=gravity-icon-results.entry.js.map